/**
 * The finder's form props, shared by the server-rendered shell, the island's
 * BirthDetailsForm and BirthToolFormShell.parity.test.tsx, so every frame
 * before and after the island loads reads the same words. No name field: the
 * answer is the seeker's birth star, and a name adds nothing to it.
 */
export const FINDER_FORM = {
  language: "en",
  submitLabel: "Find My Nakshatra",
  collectName: false,
} as const;

/**
 * One box for every state of the finder slot: the shell, the loading shell,
 * the live form and the verdict each fill the slot's reserved height (its
 * min-height), so no swap moves the page below it. The action button sits at
 * the foot of the box in every state, so an error appearing above it moves
 * nothing already on screen. The form's submit button keeps one 48 px height:
 * the shared Button is 48 px with its label but 44 px with its loading
 * spinner, so the error that ends the loading state would otherwise grow it
 * 4 px upward after the input window (measured 2026-10-06).
 */
export const FINDER_FRAME =
  "mx-auto flex w-full max-w-md flex-1 flex-col [&>form]:flex [&>form]:flex-1 [&>form]:flex-col [&>form>:last-child]:mt-auto [&>form>:last-child]:min-h-12";
